import { ContentTypes } from '~/types/adamTypes';

const NOT_MANAGED_CATEOGRIES = [
  ContentTypes.VideoRecorder,
  ContentTypes.VideoRecorderResult,
];

export const NEED_REFACTOR_TREE_CATEGORIES = [
  ContentTypes.InterDisciplineInfoIntox,
  ContentTypes.InterDisciplineDailyQuiz,
];

const NOT_USED_FOR_STATS = [
  ContentTypes.Extra,
  ContentTypes.DimensionTest,
  ContentTypes.InterDisciplineInfoIntox,
  ContentTypes.InterDisciplineDailyQuiz,
  ContentTypes.InterDisciplineActu,
  ContentTypes.InterDisciplineFocusOn,
];

export const cleanEmptyNotManagedOutDatedCategories = (
  data: CategorySchema | CategorySchema[],
  filterForStats: boolean = false
) => {
  const isNotManagedCategory = (cat) => {
    return NOT_MANAGED_CATEOGRIES.includes(cat.contentType);
  };

  const isNotUsedForStats = (cat) => {
    if (!filterForStats) return false;
    return NOT_USED_FOR_STATS.includes(cat.contentType);
  };

  const isInVisibilityDate = (cat) => {
    if (
      !cat.visibilityEndDate ||
      !cat.visibilityStartDate ||
      !cat.autoVisibility
    )
      return true;
    const date = new Date();
    return (
      date >= new Date(cat.visibilityStartDate) &&
      date <= new Date(cat.visibilityEndDate)
    );
  };

  const hasChildren = (cat) => {
    return (cat.children && cat.children.length > 0) ?? false;
  };

  const hasExercises = (cat) => {
    return (cat.exercises && cat.exercises.length > 0) ?? false;
  };

  const hasPosts = (cat) => {
    return (cat.posts && cat.posts.length > 0) ?? false;
  };

  const hasEssentialsArray = (cat) => {
    return (cat.essentialsArray && cat.essentialsArray.length > 0) ?? false;
  };

  const hasAnnalsArray = (cat) => {
    return (cat.annalsArray && cat.annalsArray.length > 0) ?? false;
  };

  const isDeepLink = (cat) => {
    return (cat.deeplink && cat.deeplink.length > 0) ?? false;
  };

  const needRefactorTree = (cat) => {
    return NEED_REFACTOR_TREE_CATEGORIES.includes(cat.contentType);
  };

  const getCategoryWithExerciseAndDisciplineId = (
    cat: CategorySchema,
    disciplineId: string = null
  ) => {
    if (cat.exercises && cat.exercises.length > 0) {
      cat.disciplineId = disciplineId;
      return cat;
    }
    if (cat.contentType === ContentTypes.Discipline) {
      disciplineId = cat.id;
    }
    for (const child of cat.children) {
      const childWithExercises = getCategoryWithExerciseAndDisciplineId(
        child,
        disciplineId
      );
      if (
        childWithExercises &&
        childWithExercises.exercises &&
        childWithExercises.exercises.length > 0
      ) {
        return childWithExercises;
      }
    }
  };

  const refactorTree = (cat) => {
    const exerciseCat = getCategoryWithExerciseAndDisciplineId(cat);
    if (!exerciseCat) return null;
    const exercise = exerciseCat.exercises.length
      ? exerciseCat.exercises[0]
      : null;
    const { disciplineId } = exerciseCat;
    let slug;

    switch (cat.contentType) {
      case ContentTypes.InterDisciplineInfoIntox:
        slug = 'info-intox';
        break;
      case ContentTypes.InterDisciplineDailyQuiz:
        slug = 'quiz-du-jour';
        break;
    }
    if (exercise) {
      exercise.slug = slug;
    }
    return {
      ...cat,
      disciplineId,
      exercises: [exercise],
      children: [],
    };
  };

  const isEmpty = (cat) => {
    if (
      !hasChildren(cat) &&
      !hasExercises(cat) &&
      !hasPosts(cat) &&
      !hasEssentialsArray(cat) &&
      !hasAnnalsArray(cat) &&
      !isDeepLink(cat)
    ) {
      return true;
    }
    return false;
  };

  const clean = (data) => {
    if (Array.isArray(data)) {
      return data.map((c) => {
        c = clean(c);
        return c;
      });
    } else if (data.children) {
      data.children = data.children.reduce((acc, current) => {
        if (
          !isNotManagedCategory(current) &&
          !isNotUsedForStats(current) &&
          isInVisibilityDate(current)
        ) {
          if (!isEmpty(current)) {
            acc.push(current);
          }
        }

        return acc;
      }, []);
      data.children.forEach((c) => {
        c = clean(c);
      });
    }
    return data;
  };

  const checkRefactorTree = (data) => {
    if (Array.isArray(data)) {
      return data.reduce((cats, current) => {
        current = checkRefactorTree(current);
        if (current) cats.push(current);
        return cats;
      }, []);
    } else if (needRefactorTree(data)) {
      return refactorTree(data);
    } else if (data.children) {
      data.children = data.children.reduce((cats, current) => {
        current = checkRefactorTree(current);
        if (current) cats.push(current);
        return cats;
      }, []);
    }
    return data;
  };
  data = clean(data);
  data = checkRefactorTree(data);
  return data;
};
